function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVarieties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.996 511.996",
    style: {
      enableBackground: "new 0 0 511.996 511.996"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDD45"
    },
    d: "M239.719,296.499c10.174,0,16.214-11.372,10.503-19.792 c-22.765-33.566-73.22-95.865-121.315-72.725c-40.02,19.255-75.372,50.057-96.535,70.773 c-8.123,7.952-2.494,21.744,8.874,21.744L239.719,296.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M239.719,296.498h-42.926c10.17,0,16.21-11.368,10.498-19.789 c-15.786-23.288-44.899-60.39-77.311-73.22c47.775-21.722,97.643,39.898,120.244,73.22 C255.929,285.129,249.889,296.498,239.719,296.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC7F69"
    },
    d: "M331.424,438.789c-6.299-5.008-9.119-13.182-7.737-21.109 c5.729-32.85,6.927-67.243,5.697-99.693H25.545c-1.23,32.45-0.032,66.843,5.697,99.693 c1.383,7.927-1.438,16.101-7.737,21.109c-6.19,4.921-13.253,13.715-15.849,29.004c-1.142,6.726,4.044,12.87,10.866,12.87 h317.884c6.822,0,12.008-6.144,10.866-12.87C344.676,452.504,337.614,443.71,331.424,438.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D46A50"
    },
    d: "M347.273,467.793c-2.596-15.289-9.659-24.083-15.849-29.004 c-6.299-5.008-9.119-13.182-7.737-21.109c5.729-32.85,6.927-67.243,5.697-99.693H25.545 c-0.571,15.056-0.609,30.531,0.076,46.076h120.886c0.769,18.089,2.522,36.28,5.616,54.02 c1.374,7.876-1.429,15.998-7.687,20.974c-6.151,4.89-13.168,13.627-15.748,28.819c-1.135,6.683,4.018,12.788,10.797,12.788 h196.922C343.229,480.664,348.415,474.519,347.273,467.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39382"
    },
    d: "M335.753,333.687H19.176c-6.084,0-11.017-4.932-11.017-11.017v-28.78 c0-6.084,4.932-11.017,11.017-11.017h316.577c6.084,0,11.017,4.932,11.017,11.017v28.78 C346.77,328.754,341.837,333.687,335.753,333.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC7F69"
    },
    d: "M346.768,293.891v28.78c0,6.08-4.93,11.02-11.01,11.02h-193.69 c0.25-17.52,1.27-34.64,2.75-50.82h190.94C341.838,282.871,346.768,287.811,346.768,293.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39382"
    },
    d: "M346.765,293.892v28.778c0,6.083-4.924,11.017-11.017,11.017H297.41 c6.083,0,11.017-4.933,11.017-11.017v-28.778c0-6.083-4.933-11.017-11.017-11.017h38.338 C341.841,282.876,346.765,287.809,346.765,293.892z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDD45"
    },
    d: "M448.925,141.727c11.514,0,18.348-12.869,11.886-22.397 c-25.762-37.984-82.858-108.484-137.284-82.298c-45.288,21.789-85.294,56.647-109.242,80.089 c-9.193,8.999-2.822,24.606,10.042,24.606L448.925,141.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M448.926,141.726H400.35c11.509,0,18.344-12.865,11.88-22.394 c-17.865-26.354-50.809-68.339-87.487-82.859c54.064-24.582,110.496,45.15,136.072,82.859 C467.269,128.861,460.435,141.726,448.926,141.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39382"
    },
    d: "M480.905,418.083c20.172-115.661-16.174-250.588-16.174-250.588H206.504 c0,0-36.346,134.926-16.174,250.588c1.374,7.876-1.429,15.998-7.687,20.974c-6.151,4.89-13.168,13.627-15.748,28.819 c-1.135,6.683,4.018,12.788,10.797,12.788h315.851c6.778,0,11.931-6.105,10.797-12.788 c-2.58-15.192-9.597-23.929-15.748-28.819C482.333,434.081,479.531,425.959,480.905,418.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC7F69"
    },
    d: "M206.504,167.495c0,0-4.625,17.192-9.659,44.528h239.449 c9.077,49.303,19.484,131.662,6.51,206.062c-1.371,7.872,1.428,16.001,7.691,20.969 c6.149,4.892,13.164,13.63,15.744,28.822c1.142,6.682-4.017,12.783-10.794,12.783h38.102 c6.777,0,11.927-6.101,10.794-12.783c-2.579-15.191-9.595-23.929-15.753-28.822c-6.254-4.969-9.062-13.098-7.681-20.969 c20.17-115.668-16.172-250.592-16.172-250.592L206.504,167.495z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A999"
    },
    d: "M474.8,179.84H196.434c-6.046,0-10.946-4.901-10.946-10.946v-28.596 c0-6.046,4.901-10.946,10.946-10.946H474.8c6.046,0,10.946,4.901,10.946,10.946v28.596 C485.747,174.939,480.846,179.84,474.8,179.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39382"
    },
    d: "M485.742,140.3v28.593c0,6.044-4.892,10.946-10.946,10.946h-38.093 c6.044,0,10.946-4.902,10.946-10.946V140.3c0-6.044-4.902-10.946-10.946-10.946h38.093 C480.85,129.354,485.742,134.256,485.742,140.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M349.112,374.108c0.621-1.252,0.621-2.732,0-3.984 c-5.527-11.144-17.018-18.807-30.301-18.807c-13.283,0-24.774,7.662-30.301,18.807c-0.621,1.252-0.621,2.732,0,3.984 c5.527,11.145,17.018,18.807,30.301,18.807C332.094,392.914,343.585,385.252,349.112,374.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M282.055,307.051c1.252-0.621,2.732-0.621,3.984,0 c11.144,5.527,18.807,17.018,18.807,30.301c0,13.283-7.662,24.774-18.807,30.301c-1.252,0.621-2.732,0.621-3.984,0 c-11.145-5.527-18.807-17.018-18.807-30.301C263.249,324.069,270.911,312.578,282.055,307.051z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M395.701,327.519c0.621-1.252,0.621-2.732,0-3.984 c-5.527-11.144-17.018-18.807-30.301-18.807c-13.283,0-24.774,7.662-30.301,18.807c-0.621,1.252-0.621,2.732,0,3.984 c5.527,11.145,17.018,18.807,30.301,18.807C378.683,346.326,390.174,338.664,395.701,327.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M328.644,260.462c1.252-0.621,2.732-0.621,3.984,0 c11.144,5.527,18.807,17.018,18.807,30.301c0,13.283-7.662,24.774-18.807,30.301c-1.252,0.621-2.732,0.621-3.984,0 c-11.145-5.527-18.807-17.018-18.807-30.301C309.837,277.48,317.499,265.989,328.644,260.462z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC83A"
    },
    d: "M413.335,239.977c1.324,0.446,2.371,1.493,2.817,2.817 c3.972,11.788,1.265,25.332-8.127,34.724c-9.392,9.392-22.936,12.1-34.724,8.127c-1.324-0.446-2.371-1.493-2.817-2.817 c-3.972-11.788-1.265-25.332,8.127-34.724S401.547,236.004,413.335,239.977z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M28.568,282.871c0.19-2.87,1.39-5.75,3.8-8.12c21.17-20.71,56.52-51.51,96.54-70.77c22.91-11.02,46.35-2.66,67.08,12.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M177.688,480.661H18.518c-6.82,0-12-6.14-10.86-12.87c2.59-15.29,9.66-24.08,15.85-29c6.3-5.01,9.12-13.18,7.73-21.11 c-4.81-27.6-6.42-56.29-6.08-83.99"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M183.234,333.687H19.176c-6.084,0-11.017-4.932-11.017-11.017v-28.78c0-6.084,4.932-11.017,11.017-11.017h166.312"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M284.808,59.301c12.25-8.15,25.25-15.79,38.72-22.27c54.42-26.19,111.52,44.31,137.28,82.3c2.15,3.17,2.83,6.71,2.36,10.02"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M210.088,129.351c-0.61-4.21,0.61-8.72,4.2-12.23c11.35-11.11,26.32-24.79,43.74-38.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M184.688,363.681c-3.28-78.37,12.07-154.74,18.8-183.84"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M467.748,179.841c8.29,35.87,29.68,143.52,13.16,238.24c-1.38,7.88,1.43,16,7.68,20.98c6.15,4.89,13.17,13.62,15.75,28.81 c1.14,6.69-4.02,12.79-10.8,12.79h-315.85c-6.77,0-11.93-6.1-10.79-12.79c2.58-15.19,9.59-23.92,15.74-28.81 c6.26-4.98,9.07-13.1,7.69-20.98c-1.23-7.04-2.24-14.15-3.07-21.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M353.616,129.351H196.434c-6.045,0-10.946,4.901-10.946,10.947v28.595c0,6.046,4.901,10.947,10.946,10.947H474.8 c6.045,0,10.946-4.901,10.946-10.947v-28.595c0-6.046-4.901-10.947-10.946-10.947h-88.022"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M349.112,374.108c0.621-1.252,0.621-2.732,0-3.984c-5.527-11.144-17.018-18.807-30.301-18.807 c-13.283,0-24.774,7.662-30.301,18.807c-0.621,1.252-0.621,2.732,0,3.984c5.527,11.145,17.018,18.807,30.301,18.807 C332.094,392.914,343.585,385.252,349.112,374.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M282.055,307.051c1.252-0.621,2.732-0.621,3.984,0c11.144,5.527,18.807,17.018,18.807,30.301 c0,13.283-7.662,24.774-18.807,30.301c-1.252,0.621-2.732,0.621-3.984,0c-11.145-5.527-18.807-17.018-18.807-30.301 C263.249,324.069,270.911,312.578,282.055,307.051z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M395.701,327.519c0.621-1.252,0.621-2.732,0-3.984c-5.527-11.144-17.018-18.807-30.301-18.807 c-13.283,0-24.774,7.662-30.301,18.807c-0.621,1.252-0.621,2.732,0,3.984c5.527,11.145,17.018,18.807,30.301,18.807 C378.683,346.326,390.174,338.664,395.701,327.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M328.644,260.462c1.252-0.621,2.732-0.621,3.984,0c11.144,5.527,18.807,17.018,18.807,30.301 c0,13.283-7.662,24.774-18.807,30.301c-1.252,0.621-2.732,0.621-3.984,0c-11.145-5.527-18.807-17.018-18.807-30.301 C309.837,277.48,317.499,265.989,328.644,260.462z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M413.335,239.977c1.324,0.446,2.371,1.493,2.817,2.817c3.972,11.788,1.265,25.332-8.127,34.724 c-9.392,9.392-22.936,12.1-34.724,8.127c-1.324-0.446-2.371-1.493-2.817-2.817c-3.972-11.788-1.265-25.332,8.127-34.724 S401.547,236.004,413.335,239.977z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 371.25,
    y1: 284.879,
    x2: 253.311,
    y2: 402.818
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M488.592,439.057h-71.603c-7.015,0-12.702-5.687-12.702-12.702v0c0-7.015,5.687-12.702,12.702-12.702"
  }))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 362.449,
    y1: 439.057,
    x2: 318.811,
    y2: 439.057
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_00000092458275008704644780000017381933233849539459_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 333.809,
    y1: 66.639,
    x2: 333.809,
    y2: 66.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_00000024681243699711382980000007469373406185669284_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 353.844,
    y1: 81.154,
    x2: 353.844,
    y2: 81.084
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_00000068659357593218344400000004478379445108720270_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 279.857,
    y1: 102.215,
    x2: 279.857,
    y2: 102.145
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_00000140699119910948384390000005966222870086973603_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 408.82,
    y1: 102.215,
    x2: 408.82,
    y2: 102.145
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarieties);
export default __webpack_public_path__ + "static/media/varieties.487e5a28cdfcc0bd42bad3100e0b571a.svg";
export { ForwardRef as ReactComponent };